/**
 * The warn-subtle triage strip shown on unknown/ambiguous threads (README
 * §3): eyebrow + explanation + Match to contact · Create contact · Park ·
 * Dismiss. Presentational — `ThreadPane` wires each callback to the
 * operations layer (resolve-identity, or opening the Match modal).
 */
import { Button } from '../ui'

export interface TriageStripProps {
  onMatch: () => void
  onCreateContact: () => void
  onPark: () => void
  onDismiss: () => void
}

export function TriageStrip({ onMatch, onCreateContact, onPark, onDismiss }: TriageStripProps) {
  return (
    <div data-testid="triage-strip" className="flex flex-wrap items-center gap-3 bg-warn-subtle px-4 py-3">
      <div className="flex-1">
        <p className="text-[10px] font-semibold uppercase tracking-[.08em] text-warn">Unresolved identity</p>
        <p className="text-[12px] text-mid">This handle has not been matched to a known contact yet.</p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button variant="secondary" onClick={onMatch}>
          Match to contact
        </Button>
        <Button variant="secondary" onClick={onCreateContact}>
          Create contact
        </Button>
        <Button variant="secondary" onClick={onPark}>
          Park
        </Button>
        <Button variant="secondary" onClick={onDismiss}>
          Dismiss
        </Button>
      </div>
    </div>
  )
}
